export default {"src":"/_next/static/media/compressor.67d16604.svg","height":132,"width":132,"blurWidth":0,"blurHeight":0};